import Dialog from "@mui/material/Dialog"
import CloseIcon from "@mui/icons-material/Close"
import IconButton from "@mui/material/IconButton"
import AppBar from "@mui/material/AppBar"
import Toolbar from "@mui/material/Toolbar"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import Paper from "@mui/material/Paper"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import TextField from "@mui/material/TextField"
import {
	Autocomplete,
	Checkbox,
	createTheme,
	DialogContent,
	FormControl,
	FormControlLabel,
	Grid,
	InputAdornment,
	InputLabel,
	Link,
	useMediaQuery,
} from "@mui/material"
import Slide from "@mui/material/Slide"
import { forwardRef, useEffect, useState } from "react"
import { useContext } from "react"
import { dateToFirebaseTimestamp, firebaseTimeStampToDate, formatLicenseNumber, statuses } from "../util/helpers"
import PostDocuments from "./PostDocuments"
import { AdminContext } from "../views/Admin"
import {
	adminCreateFakeBid,
	adminGeneratePriceScore,
	adminGetCarDescription,
	adminGetPostsV2,
	createPostV2,
	extUpdatePostV2,
} from "../util/firebase"
import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"
import "dayjs/locale/he"
import AddIcon from "@mui/icons-material/Add"
import DeleteIcon from "@mui/icons-material/Delete"
import { NumericFormat } from "react-number-format"
import SimilarPostsDialog from "./SimilarPostsDialog"
import FakeBidDialog from "./FakeBidDialog"

const mdTheme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
		white: {
			main: "white",
		},
	},
})

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />
})

const NumericFormatCustom = forwardRef(function NumericFormatCustom(props, ref) {
	const { onChange, ...other } = props

	return (
		<NumericFormat
			{...other}
			getInputRef={ref}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				})
			}}
			thousandSeparator
			valueIsNumericString
		/>
	)
})

const tagsArray = ["קטן", "משפחתי", "פנאי-שטח", "יוקרה", "ספורט", "מסחרי"]

const PostActionsDialog = () => {
	//const postAdminContext = useContext(PostAdminContext)

	const matches = useMediaQuery(mdTheme.breakpoints.up("md"))
	const [postStatus, setPostStatus] = useState("")
	const [postPriceScore, setPostPriceScore] = useState("")
	const [savePriceScoreValues, setSavePriceScoreValues] = useState(true)
	const [reservePrice, setReservePrice] = useState("")
	const [buyNowPrice, setBuyNowPrice] = useState("")
	const [odometer, setOdometer] = useState("")
	const [auctionEnabled, setAuctionEnabled] = useState(true)

	const [adminComments, setAdminComments] = useState("")

	const [description, setDescription] = useState("")
	const [internalComments, setInternalComments] = useState("")

	const adminContext = useContext(AdminContext)
	const handleConfirmationDialogOpen = adminContext.handleConfirmationDialogOpen
	const handleFakeSaleConfirmationDialogOpen = adminContext.handleFakeSaleConfirmationDialogOpen
	const fakeBidDialog = adminContext.fakeBidDialog
	const setFakeBidDialog = adminContext.setFakeBidDialog
	const handleOpenSnackbar = adminContext.handleOpenSnackbar
	const setPriceSearchOpen = adminContext.setPriceSearchOpen
	const setEditGovIlDataOpen = adminContext.setEditGovIlDataOpen
	const setEditGalleryOpen = adminContext.setEditGalleryOpen
	const handlePostOptionsClose = adminContext.handlePostOptionsClose
	const postOptionsOpen = adminContext.postOptionsOpen
	const post = adminContext.post
	const refreshPost = adminContext.refreshPost

	const postPriceScoreMin = adminContext.postPriceScoreMin
	const setPostPriceScoreMin = adminContext.setPostPriceScoreMin
	const postPriceScoreMax = adminContext.postPriceScoreMax
	const setPostPriceScoreMax = adminContext.setPostPriceScoreMax
	const postPriceScoreValues = adminContext.postPriceScoreValues
	const setPostPriceScoreValues = adminContext.setPostPriceScoreValues
	const bloggerDescription = adminContext.bloggerDescription
	const setBloggerDescription = adminContext.setBloggerDescription
	const userId = adminContext.userId
	const setUserId = adminContext.setUserId
	//const fakeSaleUserId = adminContext.fakeSaleUserId
	//const fakeSalePrice = adminContext.fakeSalePrice
	const setFakeSaleUserId = adminContext.setFakeSaleUserId
	const setFakeSalePrice = adminContext.setFakeSalePrice

	const [documents, setDocuments] = useState([])
	const [publicDocuments, setPublicDocuments] = useState([])

	const [postStartDateTime, setPostStartDateTime] = useState("")
	const [postEndDateTime, setPostEndDateTime] = useState("")
	const [newLicenseNumber, setNewLicenseNumber] = useState("")

	const [newPreviousOwners, setNewPreviousOwners] = useState("")
	const [newPreviousOwnersHistory, setNewPreviousOwnersHistory] = useState([])
	const [newPostDuration, setNewPostDuration] = useState("")

	const [postTags, setPostTags] = useState([])

	const [similarPostsDialog, setSimilarPostsDialog] = useState(false)
	const [similarPosts, setSimilarPosts] = useState([])

	const handlePostStatus = (e) => {
		setPostStatus(e.target.value)
	}

	const handlePostPriceScore = (e) => {
		setPostPriceScore(e.target.value)
	}

	const handlePostDuration = (e) => {
		setNewPostDuration(parseInt(e.target.value))
	}

	const handlePostPriceScoreMin = (e) => {
		setPostPriceScoreMin(e.target.value)
	}

	const handlePostPriceScoreMax = (e) => {
		setPostPriceScoreMax(e.target.value)
	}

	const handleSavePriceScoreValues = (e) => {
		setSavePriceScoreValues(e.target.checked ? true : false)
	}

	const handleAuctionEnabled = (e) => {
		setAuctionEnabled(e.target.checked ? true : false)
	}

	const handleAdminComments = (e) => {
		setAdminComments(e.target.value)
	}

	useEffect(() => {
		if (post?.status) setPostStatus(post.status)
		if (post?.priceScore) setPostPriceScore(post.priceScore ?? "")
		if (post?.priceScoreMin) setPostPriceScoreMin(post.priceScoreMin ?? "")
		if (post?.priceScoreMax) setPostPriceScoreMax(post.priceScoreMax ?? "")
		if (post?.priceScoreValues && post?.priceScoreValues.length > 0) {
			setPostPriceScoreValues(post.priceScoreValues)
			setSavePriceScoreValues(true)
		}
		if (post.reservePrice !== "null" && post.reservePrice !== undefined) setReservePrice(post.reservePrice ?? "")
		if (post.buyNowPrice) setBuyNowPrice(post.buyNowPrice ?? "")
		if (post.odometer) setOdometer(post.odometer ?? "")
		if (post.auctionEnabled) {
			setAuctionEnabled(true)
		} else {
			setAuctionEnabled(false)
		}
		if (post?.bloggerDescription) setBloggerDescription(post.bloggerDescription ?? "")
		if (post?.startDateTime) setPostStartDateTime(dayjs(firebaseTimeStampToDate(post?.startDateTime)))
		if (post?.endDateTime) setPostEndDateTime(dayjs(firebaseTimeStampToDate(post?.endDateTime)))
		if (post?.licenseNumber) setNewLicenseNumber(post.licenseNumber)
		if (post?.previousOwners) setNewPreviousOwners(post.previousOwners)
		if (post?.previousOwnersHistory) setNewPreviousOwnersHistory(post.previousOwnersHistory)
		if (post?.postDuration) setNewPostDuration(post.postDuration.toString())

		if (post?.attachments) setDocuments(post.attachments)
		if (post?.publicAttachments) setPublicDocuments(post.publicAttachments ?? [])

		if (post?.tags) setPostTags(post.tags)
		if (post?.description) setDescription(post.description ?? "")
		if (post?.internalComments) setInternalComments(post.internalComments ?? "")
		if (post?.userId) setUserId(post.userId ?? "")
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [post])

	//useEffect(() => {console.log(postTags)},[postTags])

	const handleUpdatePostGovIlData = async () => {
		try {
			const response = await createPostV2({ postId: post.id, licenseNumber: newLicenseNumber })
			if (response?.data?.status === 0) {
				await refreshPost(post.id, postStatus)
				handleOpenSnackbar("נתוני משרד הרישוי רועננו בהצלחה", "success")
			} else {
				console.log(`Create Post Error, returns ${response?.data}`)
				handleOpenSnackbar("תקלה ברענון נתוני משרד הרישוי", "error")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה ברענון נתוני משרד הרישוי", "error")
		}
	}

	const handleUpdatePostStartDateTime = async () => {
		try {
			const firebaseTimestamp = dateToFirebaseTimestamp(postStartDateTime.toDate())
			const response = await extUpdatePostV2({ id: post.id, startDateTime: firebaseTimestamp })
			if (response?.data?.status === 0) {
				await refreshPost(post.id, postStatus)
				handleOpenSnackbar("תאריך התחלה עודכן בהצלחה ל - " + postStartDateTime.toDate(), "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון תאריך התחלה", "error")
		}
	}

	const handleUpdatePostEndDateTime = async () => {
		try {
			const firebaseTimestamp = dateToFirebaseTimestamp(postEndDateTime.toDate())
			const response = await extUpdatePostV2({ id: post.id, endDateTime: firebaseTimestamp })
			if (response?.data?.status === 0) {
				await refreshPost(post.id, postStatus)
				handleOpenSnackbar("תאריך סיום עודכן בהצלחה ל - " + postEndDateTime.toDate(), "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון תאריך סיום", "error")
		}
	}

	const handleUpdatePostConfirm = async () => {
		try {
			const response = await extUpdatePostV2({ id: post.id, status: postStatus })
			if (response?.data?.status === 0) {
				await refreshPost(post.id, postStatus)
				handleOpenSnackbar("סטטוס עודכן בהצלחה ל - " + statuses[postStatus], "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון סטטוס", "error")
		}
	}

	const handleUpdateFakeSalePostConfirm = async (_fakeSalePrice, _fakeSaleUserId) => {
		try {
			console.log(`fakeSalePrice = ${_fakeSalePrice}`)
			console.log(`parseInt(fakeSalePrice) = ${parseInt(_fakeSalePrice)}`)
			const response = await extUpdatePostV2({
				id: post.id,
				status: postStatus,
				boughtBy: _fakeSaleUserId,
				saleType: "BUYNOW",
				salePrice: parseInt(_fakeSalePrice),
				saleDate: dateToFirebaseTimestamp(new Date()),
			})
			if (response?.data?.status === 0) {
				await refreshPost(post.id, postStatus)
				handleOpenSnackbar("סטטוס עודכן בהצלחה ל - " + statuses[postStatus], "success")
				setFakeSalePrice("")
				setFakeSaleUserId("")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון סטטוס", "error")
			setFakeSalePrice("")
			setFakeSaleUserId("")
		}
	}

	const handleUpdatePost = () => {
		if (postStatus !== post?.status) {
			if (postStatus === "ACTIVE") {
				handleConfirmationDialogOpen(
					"שינוי לסטטוס פעיל יפרסם את המודעה + כל התמונות / מסמכים לציבור",
					"פעיל",
					handleUpdatePostConfirm
				)
			} else if (postStatus === "CLOSEDDEAL") {
				handleFakeSaleConfirmationDialogOpen(
					"שינוי לסגור עסקה מחייב להזין מחיר ומשתמש הקונה",
					"מחייב",
					handleUpdateFakeSalePostConfirm
				)
			} else {
				handleUpdatePostConfirm()
			}
		}
	}

	const handleUpdatePostDuration = async () => {
		try {
			const _newPostDuration = parseInt(newPostDuration)
			if (isNaN(_newPostDuration)) {
				handleOpenSnackbar("תקלה בעידכון משך המודעה", "error")
				return
			}
			const response = await extUpdatePostV2({
				id: post.id,
				postDuration: newPostDuration,
			})
			if (response?.data?.status === 0) {
				await refreshPost(post.id, postStatus)
				handleOpenSnackbar("משך המודעה עודכן בהצלחה", "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון משך המודעה", "error")
		}
	}

	const handleUpdatePostPriceScore = async () => {
		/* if (parseInt(postPriceScore) !== post?.priceScore) { */
		//console.log(postPriceScoreValues)
		const _newPriceScoreValues = postPriceScoreValues.map((e) => ({
			date: new Date(e.date).toISOString(),
			previousOwners: parseInt(e.previousOwners),
			price: parseInt(e.price),
		}))
		try {
			const response = await extUpdatePostV2({
				id: post.id,
				priceScore: postPriceScore,
				priceScoreMin: postPriceScoreMin,
				priceScoreMax: postPriceScoreMax,
				priceScoreValues: savePriceScoreValues ? _newPriceScoreValues : [],
				reservePrice:
					!isNaN(reservePrice) &&
					post.reservePrice !== "null" &&
					post.reservePrice !== undefined &&
					reservePrice.toString().length > 0
						? parseInt(reservePrice)
						: null,
				buyNowPrice:
					!isNaN(buyNowPrice) && buyNowPrice && buyNowPrice.toString().length > 0 ? parseInt(buyNowPrice) : null,
				auctionEnabled: auctionEnabled,
			})
			if (response?.data?.status === 0) {
				await refreshPost(post.id, postStatus)
				handleOpenSnackbar("מדד מחיר עודכן בהצלחה", "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון מדד מחיר", "error")
		}
	}

	const handleUpdatePreviousOwnersHistory = async () => {
		/* if (parseInt(postPriceScore) !== post?.priceScore) { */
		try {
			const response = await extUpdatePostV2({
				id: post.id,
				previousOwners: parseInt(newPreviousOwners),
				previousOwnersHistory: newPreviousOwnersHistory,
			})
			if (response?.data?.status === 0) {
				await refreshPost(post.id, postStatus)
				handleOpenSnackbar("יד הרכב עודכן בהצלחה", "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון יד הרכב", "error")
		}
	}

	const handleUpdatePostTags = async () => {
		/* if (parseInt(postPriceScore) !== post?.priceScore) { */
		try {
			const response = await extUpdatePostV2({
				id: post.id,
				tags: postTags,
			})
			if (response?.data?.status === 0) {
				await refreshPost(post.id, postStatus)
				handleOpenSnackbar("תיוג הרכב עודכן בהצלחה", "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון תיוג הרכב", "error")
		}
	}

	const handleUpdatePostOdometer = async () => {
		/* if (parseInt(postPriceScore) !== post?.priceScore) { */
		try {
			const response = await extUpdatePostV2({
				id: post.id,
				odometer: !isNaN(odometer) && odometer ? parseInt(odometer) : null,
			})
			if (response?.data?.status === 0) {
				await refreshPost(post.id, postStatus)
				handleOpenSnackbar("קילומטרז׳ עודכן בהצלחה", "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון קילומטרז׳", "error")
		}
	}

	const handleUpdatePostAdminComments = async () => {
		try {
			const response = await extUpdatePostV2({ id: post.id, adminComments: adminComments })
			if (response?.data?.status === 0) {
				//await refreshPost(post.id, postStatus)
				handleOpenSnackbar("נשלחה הודעה ללקוח בהצלחה", "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בשליחת הודעה ללקוח", "error")
		}
	}

	const handleUpdatePostBloggerDescription = async () => {
		try {
			const response = await extUpdatePostV2({ id: post.id, bloggerDescription: bloggerDescription })
			if (response?.data?.status === 0) {
				//await refreshPost(post.id, postStatus)
				handleOpenSnackbar("מילה מהבלוגר עודכן בהצלחה", "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון מילה מהבלוגר", "error")
		}
	}

	const handleGetCarDescription = async () => {
		try {
			const response = await adminGetCarDescription({ make: post.make, model: post.model, year: post.year })
			if (response?.data?.status === 0) {
				setBloggerDescription(response.data.description)
				handleOpenSnackbar("מילה מהבלוגר נשלף בהצלחה", "success")
			} else {
				handleOpenSnackbar("לא נמצא תיאור רכב במאגר!", "error")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בשליפת מילה מהבלוגר", "error")
		}
	}

	const handleUpdatePostDescription = async () => {
		try {
			const response = await extUpdatePostV2({ id: post.id, description: description })
			if (response?.data?.status === 0) {
				//await refreshPost(post.id, postStatus)
				handleOpenSnackbar("תיאור הרכב עודכן בהצלחה", "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון תיאור הרכב", "error")
		}
	}

	const handleUpdatePostInternalComments = async () => {
		try {
			const response = await extUpdatePostV2({ id: post.id, internalComments: internalComments })
			if (response?.data?.status === 0) {
				//await refreshPost(post.id, postStatus)
				handleOpenSnackbar("הערות מנהלן עודכנו בהצלחה", "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון הערות מנהלן", "error")
		}
	}

	const handleUpdatePostUserId = async () => {
		try {
			const response = await extUpdatePostV2({ id: post.id, userId: userId })
			if (response?.data?.status === 0) {
				//await refreshPost(post.id, postStatus)
				handleOpenSnackbar("בעלות מודעה עודכן בהצלחה", "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון בעלות מודעה", "error")
		}
	}

	const findSimilarPosts = async () => {
		try {
			const response = await adminGetPostsV2({ make: post.make, model: post.model, year: post.year })
			if (response.data.status === 0 && response.data.posts?.length > 0) {
				const _posts = response.data.posts.filter((_post) => _post.id !== post.id && _post.priceScoreValues?.length > 0)
				if (_posts.length > 0) {
					console.log("Found " + _posts.length + " Similar posts")
					setSimilarPosts(_posts)
					setSimilarPostsDialog(true)
				} else {
					handleOpenSnackbar("לא נמצאו מודעות דומות", "error")
				}
			} else {
				handleOpenSnackbar("לא נמצאו מודעות דומות", "error")
			}
		} catch (e) {
			handleOpenSnackbar("תקלה במציאת מודעות דומות", "error")
		}
	}

	const generatePriceScore = async () => {
		try {
			const response = await adminGeneratePriceScore({ postId: post.id })
			if (response.data.status === 0) {
				setPostPriceScore(response.data.priceScore)
				setPostPriceScoreMin(response.data.priceScoreMin)
				setPostPriceScoreMax(response.data.priceScoreMax)
				setPostPriceScoreValues(response.data.history)
				setSavePriceScoreValues(true)
			} else if (response.data.status === 404) {
				handleOpenSnackbar("לא נמצאו רכבים לחילול דירוג אוטומטי", "error")
			} else {
				handleOpenSnackbar("תקלה בחילול דירוג", "error")
			}
		} catch (e) {
			handleOpenSnackbar("תקלה בחילול דירוג", "error")
		}
	}

	const handleCreateFakeBid = async (fakeBidAmount, fakeBidDateTime) => {
		//console.log("here")
		try {
			const response = await adminCreateFakeBid({
				amount: parseInt(fakeBidAmount),
				dateTime: fakeBidDateTime,
				postId: post.id,
			})
			if (response.data?.status === 0) {
				handleOpenSnackbar("בחילול הצעה ח בוצעה בהצלחה", "success")
			} else {
				handleOpenSnackbar("תקלה בחילול הצעה ח", "error")
			}
		} catch (e) {
			handleOpenSnackbar("תקלה בחילול הצעה ח", "error")
		}
	}

	const arrayRange = (start, stop, step) =>
		Array.from({ length: (stop - start) / step + 1 }, (value, index) => start + index * step)

	return (
		<Dialog
			fullScreen={!matches}
			open={postOptionsOpen}
			onClose={handlePostOptionsClose}
			TransitionComponent={Transition}
			PaperProps={{
				style: {
					backgroundColor: "#C5CAD7",
					maxHeight: "715px",
				},
			}}
			maxWidth={"md"}
			/* scroll="body" */
			/* sx={{ maxHeight: "715px"}} */
		>
			<SimilarPostsDialog
				similarPostsDialog={similarPostsDialog}
				setSimilarPostsDialog={setSimilarPostsDialog}
				similarPosts={similarPosts}
				setSimilarPosts={setSimilarPosts}
				setPostPriceScore={setPostPriceScore}
				setPostPriceScoreMin={setPostPriceScoreMin}
				setPostPriceScoreMax={setPostPriceScoreMax}
				setPostPriceScoreValues={setPostPriceScoreValues}
				setSavePriceScoreValues={setSavePriceScoreValues}
			/>
			<FakeBidDialog
				fakeBidDialog={fakeBidDialog}
				setFakeBidDialog={setFakeBidDialog}
				okCallback={(fakeBidAmount, fakeBidDateTime) => handleCreateFakeBid(fakeBidAmount, fakeBidDateTime)}
			/>
			<AppBar sx={{ position: "relative" }}>
				<Toolbar>
					<IconButton edge="start" color="inherit" onClick={handlePostOptionsClose} aria-label="close">
						<CloseIcon />
					</IconButton>
					<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
						אפשרויות מנהלן - {formatLicenseNumber(post?.licenseNumber)}
					</Typography>
				</Toolbar>
			</AppBar>
			<DialogContent dividers>
				<Grid container spacing={2} sx={{ p: 2 }}>
					<Grid item xs={12} md={true}>
						<Paper sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}>
							<Typography variant="h6">טיפול במודעה</Typography>
							<div
								style={{
									display: "flex",
									flexDirection: matches ? "row" : "column",
									justifyContent: "center",
									alignItems: matches ? "center" : "normal",
									height: "100%",
								}}
							>
								<Button
									sx={{ m: 2, width: matches ? "120px" : "auto" }}
									variant="contained"
									onClick={() => window.open(process.env.REACT_APP_WEBSITE_BASE_URL + "car?postId=" + post?.id)}
								>
									צפיה
								</Button>
								<Button
									sx={{
										m: 2,
										width: matches ? "120px" : "auto",
										backgroundColor: mdTheme.palette.secondary.main,
										"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
									}}
									variant="contained"
									onClick={() => window.open(process.env.REACT_APP_WEBSITE_BASE_URL + "post?postId=" + post?.id)}
								>
									עריכה
								</Button>
								<Button
									sx={{
										m: 2,
										width: matches ? "120px" : "auto",
										backgroundColor: mdTheme.palette.secondary.main,
										"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
									}}
									variant="contained"
									onClick={() => setEditGalleryOpen(true)}
								>
									עריכת תמונות
								</Button>
							</div>
						</Paper>
					</Grid>
					<Grid item xs={12} md={12}>
						<Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
							<Typography variant="h6">קביעת מדד מחיר</Typography>
							<div
								style={{
									display: "flex",
									flexDirection: matches ? "row" : "column",
									justifyContent: "center",
									alignItems: "center",
								}}
							>
								<FormControlLabel
									/* disabled={!postPriceScoreValues} */
									control={<Checkbox checked={auctionEnabled} onChange={(e) => handleAuctionEnabled(e)} />}
									label="מכירה פומבית?"
								/>
							</div>
							<div
								style={{
									display: "flex",
									flexDirection: matches ? "row" : "column",
									justifyContent: "center",
									alignItems: "center",
								}}
							>
								{/* <Typography variant="subtitle1">מחיר מינימום:</Typography> */}
								{/* <Typography variant="body1" sx={{ ml: 1, color: mdTheme.palette.secondary.main }}>
									{"\u20aa" + new Intl.NumberFormat().format(parseInt(post.reservePrice))}
								</Typography> */}
								<TextField
									disabled={!auctionEnabled}
									label={"מחיר מינימום"}
									value={reservePrice}
									onChange={(e) => {
										setReservePrice(e.target.value)
									}}
									InputProps={{
										endAdornment: <InputAdornment position="start">ש״ח</InputAdornment>,
										inputComponent: NumericFormatCustom,
									}}
									size="small"
									sx={{ mt: 0, ml: 0, mr: 2, mb: 0, maxHeight: "36px", minWidth: "80px" }}
								/>
							</div>
							<div
								style={{
									display: "flex",
									flexDirection: matches ? "row" : "column",
									justifyContent: "center",
									alignItems: "center",
									marginTop: "10px",
								}}
							>
								{/* <Typography variant="subtitle1">מחיר קניה מיידית:</Typography> */}
								{/* <Typography variant="body1" sx={{ ml: 1, color: mdTheme.palette.secondary.main }}>
									{"\u20aa" + new Intl.NumberFormat().format(parseInt(post.buyNowPrice))}
								</Typography> */}
								<TextField
									label={"מחיר קניה מיידית"}
									value={buyNowPrice}
									onChange={(e) => {
										setBuyNowPrice(e.target.value)
									}}
									InputProps={{
										endAdornment: <InputAdornment position="start">ש״ח</InputAdornment>,
										inputComponent: NumericFormatCustom,
									}}
									size="small"
									sx={{ mt: 0, ml: 0, mr: 2, mb: 0, maxHeight: "36px", minWidth: "80px" }}
								/>
							</div>
							<div
								style={{
									display: "flex",
									flexDirection: matches ? "row" : "column",
									justifyContent: "center",
									alignItems: "center",
								}}
							>
								{/* <Typography variant="subtitle1">מחיר מינימום:</Typography> */}
								{/* <Typography variant="body1" sx={{ ml: 1, color: mdTheme.palette.secondary.main }}>
									{"\u20aa" + new Intl.NumberFormat().format(parseInt(post.reservePrice))}
								</Typography> */}
								<Button
									sx={{ m: 2, width: matches ? "120px" : "auto" }}
									variant="contained"
									onClick={() => setFakeBidDialog(true)}
								>
									חילול הצעה ח׳
								</Button>
							</div>
							<div
								style={{
									display: "flex",
									flexDirection: matches ? "row" : "column",
									justifyContent: "center",
								}}
							>
								<div>
									<FormControl sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} size="small">
										<InputLabel>מחיר</InputLabel>
										<Select size="small" value={postPriceScore} label="מחיר" onChange={handlePostPriceScore}>
											{[
												{ key: 1, value: "1 - מחיר נמוך מאוד" },
												{ key: 2, value: "2 - מחיר נמוך" },
												{ key: 3, value: "3 - מחיר הוגן" },
												{ key: 4, value: "4 - מחיר גבוה" },
												{ key: 5, value: "5 - מחיר גבוה מאוד" },
											].map((key) => (
												<MenuItem key={key.key} value={key.key}>
													{key.value}
												</MenuItem>
											))}
										</Select>
									</FormControl>
									<TextField
										label={"טווח תחתון"}
										value={postPriceScoreMin}
										onChange={(e) => handlePostPriceScoreMin(e)}
										size="small"
										sx={{ mt: 0, ml: 2, mr: 2, mb: 2, maxHeight: "36px", maxWidth: "150px", display: "block" }}
										InputProps={{
											endAdornment: <InputAdornment position="start">ש״ח</InputAdornment>,
											inputComponent: NumericFormatCustom,
										}}
									/>
									<TextField
										label={"טווח עליון"}
										value={postPriceScoreMax}
										onChange={(e) => handlePostPriceScoreMax(e)}
										size="small"
										sx={{ mt: 0, ml: 2, mr: 2, mb: 0, maxHeight: "36px", maxWidth: "150px" }}
										InputProps={{
											endAdornment: <InputAdornment position="start">ש״ח</InputAdornment>,
											inputComponent: NumericFormatCustom,
										}}
									/>
									{postPriceScoreValues?.length > 0 && (
										<FormControlLabel
											disabled={!postPriceScoreValues}
											control={
												<Checkbox checked={savePriceScoreValues} onChange={(e) => handleSavePriceScoreValues(e)} />
											}
											label="הצג היסטוריית עסקאות?"
										/>
									)}
									{postPriceScoreValues &&
										postPriceScoreValues.map((elem, i) => (
											<div
												key={i}
												style={{
													display: "flex",
													flexDirection: matches ? "row" : "column",
													marginBottom: "10px",
													marginTop: "10px",
												}}
											>
												<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"he"}>
													<DatePicker
														label="תאריך"
														value={dayjs(new Date(elem.date))}
														onChange={(newValue) => {
															setPostPriceScoreValues((prevState) => {
																const newState = [...prevState]
																newState[i] = { ...newState[i], date: newValue }
																return newState
															})
														}}
														slotProps={{ textField: { size: "small" } }}
														sx={{ minWidth: "110px" }}
													/>
												</LocalizationProvider>
												<TextField
													label={"יד"}
													value={elem.previousOwners.toString()}
													onChange={(e) => {
														setPostPriceScoreValues((prevState) => {
															const newState = [...prevState]
															newState[i] = { ...newState[i], previousOwners: e.target.value }
															return newState
														})
													}}
													size="small"
													sx={{
														mt: matches ? 0 : 1,
														ml: 1,
														mr: 1,
														mb: matches ? 0 : 2,
														maxHeight: "36px",
														maxWidth: "40px",
													}}
												/>
												<TextField
													label={"מחיר"}
													value={elem.price.toString()}
													onChange={(e) => {
														setPostPriceScoreValues((prevState) => {
															const newState = [...prevState]
															newState[i] = { ...newState[i], price: e.target.value }
															return newState
														})
													}}
													InputProps={{
														endAdornment: <InputAdornment position="start">ש״ח</InputAdornment>,
														inputComponent: NumericFormatCustom,
													}}
													size="small"
													sx={{ mt: 0, ml: 0, mr: 2, mb: 0, maxHeight: "36px", minWidth: "80px" }}
												/>
												<IconButton
													onClick={() => {
														setPostPriceScoreValues((prevState) => prevState.filter((e, t) => t !== i))
													}}
												>
													<DeleteIcon />
												</IconButton>
											</div>
										))}
									<IconButton
										onClick={() => {
											setPostPriceScoreValues((prevState) => {
												const _prevState = [...prevState]
												_prevState.push({ previousOwners: "", date: "", price: "" })
												return _prevState
											})
										}}
									>
										<AddIcon />
									</IconButton>
									<Typography>מס׳ מודעות שנבחרו: {postPriceScoreValues?.length}</Typography>
								</div>
								<div style={{ display: "flex", flexDirection: "column" }}>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											backgroundColor: mdTheme.palette.secondary.main,
											"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
											maxHeight: "36px",
										}}
										variant="contained"
										onClick={handleUpdatePostPriceScore}
									>
										עדכון
									</Button>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											backgroundColor: mdTheme.palette.primary.main,
											"&:hover": { backgroundColor: mdTheme.palette.primary.main },
											maxHeight: "36px",
										}}
										variant="contained"
										onClick={findSimilarPosts}
									>
										חיפוש מודעות דומות
									</Button>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											backgroundColor: mdTheme.palette.primary.main,
											"&:hover": { backgroundColor: mdTheme.palette.primary.main },
											maxHeight: "36px",
										}}
										variant="contained"
										onClick={generatePriceScore}
									>
										חישוב דירוג
									</Button>
									<Link sx={{ cursor: "pointer" }} onClick={() => setPriceSearchOpen(true)}>
										מערכת חיפוש מחירים היסטוריים
									</Link>
								</div>
							</div>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
							<Typography variant="h6">אישור מסמכים</Typography>
							<PostDocuments
								documents={documents}
								setDocuments={setDocuments}
								publicDocuments={publicDocuments}
								setPublicDocuments={setPublicDocuments}
							/>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
							<Typography variant="h6">התכתבות עם לקוח</Typography>
							<div
								style={{
									display: "flex",
									flexDirection: "column" /* justifyContent: "center", alignItems: "center" */,
								}}
							>
								<div
									style={{ display: "flex", flexDirection: matches ? "row" : "column" /* alignItems: "flex-start" */ }}
								>
									<Paper sx={{ maxWidth: matches ? "50%" : "auto", m: 2 }}>
										<Typography variant="subtitle2" sx={{ display: "block", fontWeight: "600" }}>
											הערה מלקוח
										</Typography>
										<Typography variant="body2" sx={{ m: 2 }}>
											{post.comments}
										</Typography>
									</Paper>
									<TextField
										fullWidth={matches}
										label="הערה ללקוח"
										multiline
										rows={5}
										sx={{ m: 2 /* , height: "100%" */ }}
										value={adminComments}
										onChange={handleAdminComments}
									/>
								</div>
								<Button
									sx={{
										m: 2,
										width: matches ? "120px" : "auto",
										backgroundColor: mdTheme.palette.secondary.main,
										"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
									}}
									variant="contained"
									onClick={handleUpdatePostAdminComments}
								>
									שליחה
								</Button>
							</div>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
							<Typography variant="h6">תיאור הרכב</Typography>
							<div
								style={{
									display: "flex",
									flexDirection: "column" /* justifyContent: "center", alignItems: "center" */,
								}}
							>
								<TextField
									fullWidth={false}
									label="הזנת תוכן"
									multiline
									rows={5}
									sx={{ m: 2 /* , height: "100%" */ }}
									value={description}
									onChange={(e) => setDescription(e.target.value)}
								/>
								<Button
									sx={{
										m: 2,
										width: matches ? "120px" : "auto",
										backgroundColor: mdTheme.palette.secondary.main,
										"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
									}}
									variant="contained"
									onClick={handleUpdatePostDescription}
								>
									עידכון
								</Button>
							</div>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
							<Typography variant="h6">מילה מהבלוגר שלנו</Typography>
							<div
								style={{
									display: "flex",
									flexDirection: "column" /* justifyContent: "center", alignItems: "center" */,
								}}
							>
								<TextField
									fullWidth={false}
									label="הזנת תוכן"
									multiline
									rows={5}
									sx={{ m: 2 /* , height: "100%" */ }}
									value={bloggerDescription}
									onChange={(e) => setBloggerDescription(e.target.value)}
								/>
								<div
									style={{
										display: "flex",
										flexDirection: matches ? "row" : "column",
										columnGap: "4px",
										rowGap: "4px",
									}}
								>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											backgroundColor: mdTheme.palette.secondary.secondary,
											"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
										}}
										variant="contained"
										onClick={handleGetCarDescription}
									>
										שלוף ממאגר
									</Button>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											backgroundColor: mdTheme.palette.secondary.main,
											"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
										}}
										variant="contained"
										onClick={handleUpdatePostBloggerDescription}
									>
										עידכון
									</Button>
								</div>
							</div>
						</Paper>
					</Grid>
					<Grid item xs={12} md={true}>
						<Paper sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}>
							<div style={{ display: "flex", flexDirection: "column" }}>
								<Typography variant="h6">תאריך התחלה</Typography>
								<div
									style={{
										display: "flex",
										flexDirection: matches ? "row" : "column",
										justifyContent: "center",
										alignItems: matches ? "center" : "normal",
										height: "100%",
									}}
								>
									<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"he"}>
										<DateTimePicker
											label="תאריך פרסום מודעה"
											/* defaultValue={dayjs(firebaseTimeStampToDate(post?.startDateTime))} */
											value={postStartDateTime}
											onChange={(newValue) => setPostStartDateTime(newValue)}
											sx={{ m: 2 }}
										/>
									</LocalizationProvider>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											backgroundColor: mdTheme.palette.secondary.main,
											"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
										}}
										variant="contained"
										onClick={handleUpdatePostStartDateTime}
									>
										עדכון
									</Button>
								</div>
								<Typography variant="h6">תאריך סיום</Typography>
								<div
									style={{
										display: "flex",
										flexDirection: matches ? "row" : "column",
										justifyContent: "center",
										alignItems: matches ? "center" : "normal",
										height: "100%",
									}}
								>
									<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"he"}>
										<DateTimePicker
											label="תאריך סיום מודעה"
											/* defaultValue={dayjs(firebaseTimeStampToDate(post?.startDateTime))} */
											value={postEndDateTime}
											onChange={(newValue) => setPostEndDateTime(newValue)}
											sx={{ m: 2 }}
										/>
									</LocalizationProvider>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											backgroundColor: mdTheme.palette.secondary.main,
											"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
										}}
										variant="contained"
										onClick={handleUpdatePostEndDateTime}
									>
										עדכון
									</Button>
								</div>
								<Typography variant="h6">משך הפוסט</Typography>
								<div
									style={{
										display: "flex",
										flexDirection: matches ? "row" : "column",
										justifyContent: "center",
										alignItems: matches ? "center" : "normal",
										height: "100%",
									}}
								>
									<FormControl sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} size="small">
										<InputLabel>ימים</InputLabel>
										<Select
											/* sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} */
											size="small"
											value={newPostDuration}
											label="ימים"
											onChange={handlePostDuration}
										>
											{arrayRange(1, 14, 1).map((key) => (
												<MenuItem key={key} value={key}>
													{key}
												</MenuItem>
											))}
										</Select>
									</FormControl>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											backgroundColor: mdTheme.palette.secondary.main,
											"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
										}}
										variant="contained"
										onClick={handleUpdatePostDuration}
									>
										עדכון
									</Button>
								</div>
							</div>
						</Paper>
					</Grid>
					<Grid item xs={12} md={true}>
						<Paper sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}>
							<Typography variant="h6">נתוני משרד רישוי</Typography>
							<div style={{ display: "flex", flexDirection: "column" }}>
								<div
									style={{
										display: "flex",
										flexDirection: matches ? "row" : "column",
										justifyContent: "center",
										alignItems: matches ? "center" : "normal",
										height: "100%",
									}}
								>
									<TextField
										label={"מספר רישוי"}
										value={newLicenseNumber}
										onChange={(e) => setNewLicenseNumber(e.target.value)}
										size="small"
										sx={{ m: 2, maxHeight: "36px" }}
									/>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											/* backgroundColor: mdTheme.palette.secondary.main, */
											"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
										}}
										variant="contained"
										onClick={handleUpdatePostGovIlData}
									>
										רענון
									</Button>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											backgroundColor: mdTheme.palette.secondary.main,
											"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
										}}
										variant="contained"
										onClick={() => {
											setEditGovIlDataOpen(true)
										}}
									>
										עריכה
									</Button>
								</div>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										alignItems: "flex-start",
										height: "100%",
									}}
								>
									<TextField
										label={"יד"}
										value={newPreviousOwners}
										onChange={(e) => setNewPreviousOwners(e.target.value)}
										size="small"
										sx={{ m: 2, maxHeight: "36px" }}
									/>
									{newPreviousOwnersHistory.map((elem, i) => (
										<div key={i} style={{ display: "flex", flexDirection: "row", marginBottom: "10px" }}>
											<FormControl sx={{ minWidth: "80px", maxWidth: "120px" }}>
												<InputLabel size="small" id={`previousOwnersHistoryOwnerType${i}`}>
													סוג
												</InputLabel>
												<Select
													labelId={`previousOwnersHistoryOwnerType${i}`}
													value={elem.ownerType}
													label="סוג"
													size="small"
													onChange={(e) => {
														setNewPreviousOwnersHistory((prevState) => {
															const newState = [...prevState]
															newState[i] = { ...newState[i], ownerType: e.target.value }
															return newState
														})
													}}
												>
													<MenuItem value={"החכר"}>החכר</MenuItem>
													<MenuItem value={"השכרה"}>השכרה</MenuItem>
													<MenuItem value={"חברה"}>חברה</MenuItem>
													<MenuItem value={"סוחר"}>סוחר</MenuItem>
													<MenuItem value={"פרטי"}>פרטי</MenuItem>
												</Select>
											</FormControl>
											<FormControl sx={{ minWidth: "80px", maxWidth: "120px" }}>
												<InputLabel size="small" id={`previousOwnersHistoryYear${i}`}>
													שנה
												</InputLabel>
												<Select
													labelId={`previousOwnersHistoryYear${i}`}
													value={elem.date.toString().substring(0, 4)}
													label="שנה"
													size="small"
													onChange={(e) => {
														setNewPreviousOwnersHistory((prevState) => {
															const newState = [...prevState]
															newState[i] = {
																...newState[i],
																date: parseInt(e.target.value + prevState[i].date.toString().substring(4, 6)),
															}
															return newState
														})
													}}
												>
													{arrayRange(1990, new Date().getFullYear(), 1).map((e) => (
														<MenuItem key={e} value={e}>
															{e}
														</MenuItem>
													))}
												</Select>
											</FormControl>
											<FormControl sx={{ maxWidth: "110px" }}>
												<InputLabel size="small" id={`previousOwnersHistoryMonth${i}`}>
													חודש
												</InputLabel>
												<Select
													labelId={`previousOwnersHistoryMonth${i}`}
													value={elem.date.toString().substring(4, 6)}
													label="חודש"
													size="small"
													onChange={(e) => {
														setNewPreviousOwnersHistory((prevState) => {
															const newState = [...prevState]
															newState[i] = {
																...newState[i],
																date: parseInt(prevState[i].date.toString().substring(0, 4) + e.target.value),
															}
															return newState
														})
													}}
												>
													{arrayRange(1, 12, 1).map((e) => (
														<MenuItem key={e} value={("0" + e).slice(-2)}>
															{("0" + e).slice(-2)}
														</MenuItem>
													))}
												</Select>
											</FormControl>
											<IconButton
												onClick={() => {
													setNewPreviousOwnersHistory((prevState) => prevState.filter((e, t) => t !== i))
												}}
											>
												<DeleteIcon />
											</IconButton>
										</div>
									))}
									<IconButton
										onClick={() => {
											setNewPreviousOwnersHistory((prevState) => {
												const _prevState = [...prevState]
												_prevState.push({ ownerType: "", date: "" })
												return _prevState
											})
										}}
									>
										<AddIcon />
									</IconButton>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											/* backgroundColor: mdTheme.palette.secondary.main, */
											"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
										}}
										variant="contained"
										onClick={() => {
											console.log(newPreviousOwnersHistory)
											handleUpdatePreviousOwnersHistory()
										}}
									>
										עדכון
									</Button>
									<TextField
										label={"קילומטרז׳"}
										value={odometer}
										onChange={(e) => setOdometer(e.target.value)}
										size="small"
										sx={{ m: 2, maxHeight: "36px" }}
									/>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											/* backgroundColor: mdTheme.palette.secondary.main, */
											"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
										}}
										variant="contained"
										onClick={() => {
											handleUpdatePostOdometer()
										}}
									>
										עדכון
									</Button>
									<Autocomplete
										multiple
										id="tags-outlined"
										options={tagsArray}
										onChange={(event, value) => {
											setPostTags(value)
										}}
										value={[...postTags]}
										filterSelectedOptions
										renderInput={(params) => <TextField {...params} label="תיוג סוג רכב" placeholder="תגים..." />}
									/>
									<Button
										sx={{
											m: 2,
											width: matches ? "120px" : "auto",
											/* backgroundColor: mdTheme.palette.secondary.main, */
											"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
										}}
										variant="contained"
										onClick={() => {
											handleUpdatePostTags()
										}}
									>
										עדכון
									</Button>
								</div>
							</div>
						</Paper>
					</Grid>
					<Grid item xs={12} md={true}>
						<Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
							<Typography variant="h6">החלפת בעלות מודעה</Typography>
							<div
								style={{
									display: "flex",
									flexDirection: "column" /* justifyContent: "center", alignItems: "center" */,
								}}
							>
								<TextField
									fullWidth={false}
									label="בעלים"
									sx={{ m: 2 }}
									value={userId ?? ""}
									onChange={(e) => setUserId(e.target.value)}
								/>
								<Button
									sx={{
										m: 2,
										width: matches ? "120px" : "auto",
										backgroundColor: mdTheme.palette.secondary.main,
										"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
									}}
									variant="contained"
									onClick={handleUpdatePostUserId}
								>
									עידכון
								</Button>
							</div>
							<Typography variant="h6" sx={{ textDecoration: "underline" }}>
								שינוי סטטוס
							</Typography>
							<div
								style={{
									display: "flex",
									flexDirection: matches ? "row" : "column",
									justifyContent: "center",
								}}
							>
								<Typography variant="h6">סטטוס נוכחי:</Typography>
								<Typography variant="h5" sx={{ ml: 1, color: mdTheme.palette.secondary.main }}>
									{statuses[post?.status]}
								</Typography>
							</div>
							<div
								style={{
									display: "flex",
									flexDirection: matches ? "row" : "column",
									justifyContent: "center",
								}}
							>
								<FormControl sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} size="small">
									<InputLabel id="demo-simple-select-label">סטטוס חדש</InputLabel>
									<Select
										/* sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} */
										size="small"
										value={postStatus}
										label="סטטוס חדש"
										onChange={handlePostStatus}
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										defaultValue={post?.status}
									>
										{Object.keys(statuses).map((key) => (
											<MenuItem key={key} value={key}>
												{statuses[key]}
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<Button
									sx={{
										m: 2,
										width: matches ? "120px" : "auto",
										backgroundColor: mdTheme.palette.secondary.main,
										"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
									}}
									variant="contained"
									onClick={handleUpdatePost}
								>
									עדכון
								</Button>
							</div>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
							<Typography variant="h6">הערות מנהלן</Typography>
							<div
								style={{
									display: "flex",
									flexDirection: "column" /* justifyContent: "center", alignItems: "center" */,
								}}
							>
								<TextField
									fullWidth={false}
									label="הזנת תוכן"
									multiline
									rows={5}
									sx={{ m: 2 /* , height: "100%" */ }}
									value={internalComments}
									onChange={(e) => setInternalComments(e.target.value)}
								/>
								<Button
									sx={{
										m: 2,
										width: matches ? "120px" : "auto",
										backgroundColor: mdTheme.palette.secondary.main,
										"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
									}}
									variant="contained"
									onClick={handleUpdatePostInternalComments}
								>
									עידכון
								</Button>
							</div>
						</Paper>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	)
}

export default PostActionsDialog
